import { SELECT_TAB } from '../actionTypes';
import { contactFileActions } from '../reducer';

export default (data) => contactFileActions[SELECT_TAB](data);
